import Services from './base-services'

const service = new Services('analyticEvents')

export default {
  createEvent(payload: object) {
    return service.contentPost('user_events', payload)
  },
  findLastEventByUser(userId: number) {
    return service.contentGet(`findLastRecordByUserId/${userId}`)
  },
  updateEventDuration(payload: { user_id: string, duration_in_seconds: number }) {
    return service.contentPut('updateEventDuration/' + payload.user_id, payload)
  }
}
